import { TApplicationState } from '../../types/redux';

export function getIsSalesLeader(state: TApplicationState) {
  const {
    newbuilding: { isSalesLeader },
  } = state;

  return isSalesLeader;
}
